<template>
    <simple-button :light-theme="true" @click="onView">
        {{ toSentenceCase($t('preparation.buttons.view')) }}
    </simple-button>
</template>

<script>
import { toSentenceCase } from '@/js/utils/string-utils';

export default {
    methods: {
        toSentenceCase,
        onView() {
            this.params.onView(this.params.data.categoryKey);
        },
    },
};
</script>
